import { types } from 'mobx-state-tree';

const Category = types.model('Category', {
  id: types.identifierNumber,
  name: types.string,
  allowedItemType: types.enumeration(['VIDEO', 'DOCUMENT', 'LINK', 'TOP_BANNER', 'BOTTOM_BANNER', 'DIRECT_LINK'])
})
.actions((/*self*/) => ({

}))
.views((/*self*/) => ({

}))

export default Category;
